import styled from "@emotion/styled";
import { Nok } from "../../types/types";
import SelectBox, { menuItemType } from "../selectBox";
import theme from "../../theme";
import { Label } from "../common/Label";
import { TextInput } from "../common/TextInput";
import useGetAllCustomer from "../../hooks/useGetAllCustomer";
import { useI18n } from "../../locales";

const { sm } = theme.screen;

const InputField: React.FC<{
  data: Nok;
}> = (props) => {
  const { data } = props;
  const { t } = useI18n();

  // 사용자 연락처 리스트 가져오기
  const { data: relatedIdList } = useGetAllCustomer({
    page: 0,
    searchKey: "",
    area: "",
    limit: -1,
  });
  let relatedIdListType: menuItemType[] = [
    {
      value: -1,
      title: t.manageNok.selectOwner,
    },
  ];
  if (relatedIdList) {
    relatedIdList.list.filter((item) => {
      relatedIdListType.push({
        value: item.id,
        title: item.seq + ". " + item.name,
      });
    });
  }

  return (
    <UserInfoWrapper>
      <UserInfo>
        <RowContainer>
          {/* 사용자명 & 사용자 연락처 */}
          <InputWrapper>
            <Label text={t.manageNok.nameLabel} htmlFor="name" />
            <TextInput
              disabled
              id="name"
              name="name"
              width={"100%"}
              value={data.name}
            />
          </InputWrapper>
          <InputWrapper style={{ position: "relative" }}>
            <Label text={t.manageNok.contactLabel} htmlFor="id" />
            <TextInput
              disabled
              id="id"
              name="id"
              width={"100%"}
              value={data.id}
            />
          </InputWrapper>

          <InputWrapper>
            <Label text={t.manageNok.relationshipLabel} htmlFor="relation" />

            <TextInput
              disabled
              id="relation"
              name="relation"
              width={"100%"}
              value={data.relation}
            />
          </InputWrapper>

          <InputWrapper>
            <Label text={t.manageNok.ownerLabel} htmlFor="related_id" />

            <SelectBox
              disabled
              filter={data.related_id}
              menuItems={relatedIdListType}
              width={"100%"}
              srLabel={t.manageNok.ownerLabel}
            />
          </InputWrapper>
        </RowContainer>
      </UserInfo>
    </UserInfoWrapper>
  );
};

const UserInfoWrapper = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 40px;
  width: 100%;
  display: flex;
  gap: 44px;
  margin-bottom: 40px;
  @media (max-width: ${sm}px) {
    padding: 10px;
    padding-bottom: 20px;
  }
`;

const UserInfo = styled.div`
  width: 100%;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const RowContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 26px;
`;
export default InputField;
